import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV} from '@fortawesome/free-solid-svg-icons'
import { useCurrentPath } from '../hooks/useCurrentPath'
import { useGetUserDetailsQuery } from '../app/services/auth/authService'
import { logout, setCredentials } from '../features/auth/authSlice'
//import '../styles/header.css'

const MenuOptions = ({option_routes}) => {
  return (
    <div id='menu-options'>
      {option_routes.map((o, j) => {
        if (o.type === 'nav') {
          return <NavLink key={j} className='nav' to={o.path}>{o.name}</NavLink>
        }
      })}
    </div>
  )
}

const channels_or = { type: 'nav', path: '/rooms', name: 'Channels' }
const settings_or = { type: 'nav', path: '/settings', name: 'Settings' }
const login_or = { type: 'nav', path: '/login', name: 'Login' }
const register_or = { type: 'nav', path: '/register', name: 'Register' }
const members_or = (path_name) => {
  return { type: 'nav', path: path_name + '/members', name: 'Members' }
}
const new_channel_or = { type: 'nav', path: '/rooms/new', name: 'New channel' }
const leave_channel_or = (path_name) => {
  return { type: 'nav', path: path_name + '/leave', name: 'Leave channel' }
}

const getOptionRoutes = (path_name, path_template, is_logged_in) => {
  if (!is_logged_in) { return [] }
  switch (path_template) {
    case '/rooms': {
      return [
        new_channel_or,
        settings_or
      ]
    }
    case '/rooms/:id': {
      return (path_name === '/rooms/new')
        ? []
        : [
          members_or(path_name),
          leave_channel_or(path_name)
        ]
    }
    default: {
      return []
    }
  }
}

const Menu = () => {
  const user = useSelector((state) => state.auth.user)
  const dispatch = useDispatch()
  const location = useLocation()
  const currentPath = useCurrentPath()

  // automatically authenticate user if token is found
  const { data, isFetching, error } = useGetUserDetailsQuery('userDetails', {
    pollingInterval: 900000, // 15mins
  })
  //console.log('[Header.Menu] data=', data)

  useEffect(() => {
    if (data) {
      // Identify with Heap
      if (window.heap && data.user) {
        window.heap.identify(data.user.id);
        window.heap.addUserProperties({
          name: data.user.name,
          email: data.user.email,
          verified: data.user.verified,
          native_lang_id: data.user.native_lang_id,
          default_lang_id: data.user.default_lang_id,
        });
      }
      dispatch(setCredentials(data))
    }
    if (error) dispatch(logout())
  }, [data, error, dispatch])

  const option_routes = getOptionRoutes(location.pathname, currentPath, user !== null)
  //console.log('[Menu] option_routes =', option_routes)

  return
}

export default Menu
  
//  if (option_routes.length) {
//    return (
//      <div id='menu'>
//        <div className='login-status'>
//          <span>
//            {isFetching
//              ? `Fetching your profile...`
//              : user !== null
//              ? user.name
//              : "You're not logged in"}
//          </span>
//        </div>
//        {option_routes.length > 0 && (
//          <MenuOptions option_routes={option_routes} />
//        )}
//      </div>
//    )
//  }
